import React, { useEffect, useState,useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import { Passaggio } from "../App"
import './OrdiniOggi.css';

const OrdiniOggi = () => {

  const [ordini, setOrdini] = useState([]);
  const link = useNavigate()
  const { url } = useContext(Passaggio);
  let totale = 0
  useEffect(() => {
    caricaOrdini();
  }, []);

  const caricaOrdini = () => {
    fetch(url+"/ordiniOggi", {
      method: "GET",
      headers: {
        'Authorization': "Bearer " + sessionStorage.getItem("token"),
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.risultato == "ko" || data.risultato == undefined) {
          Swal.fire({ title: 'Login fallito. Riprova.', icon: 'warning', timer: 1500, showConfirmButton: false });
          link("/")
        } else {
          setOrdini(data.dati);
        }

      })
      .catch(() => {
        Swal.fire({
          title: "Errore caricamento ordini",
          icon: "error",
          timer: 1500,
          showConfirmButton: false
        });
      });
  };

  const eliminaOrdine = (ordineID) => {
    Swal.fire({
      title: "Eliminare ordine?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(url+`/eliminaOrdine/${ordineID}`, {
          method: "DELETE",
          headers: {
            'Authorization': "Bearer " + sessionStorage.getItem("token")
          }
        })
          .then(res => res.json())
          .then(() => {
            setOrdini(ordini.filter(o => o.ordineID !== ordineID));
          });
      }
    });
  };

  return (
    <div className="ordiniOggiPage">
      <div className="ordiniWrapper">
        <div className="contenitoreOrdini">

          <div className="headingsContainer">
            <h1>Ordini di Oggi</h1>
            <h2>Elenco ordini effettuati</h2>
          </div>

          <div className="ordiniContainer">
            {ordini.map(o => {
              totale += o.quantita * o.prezzoUnitario; // calcolo totale per l'ordine
              return (
                <div key={o.ordineID} className="ordineCard">
                  <div className="ordineTesto">
                    {o.prodottoDesc} - {o.quantita}x - €{o.prezzoUnitario}
                    <br />
                    <span className='testoClasse'>Classe: {o.classe}</span>
                  </div>

                  <button
                    className="btnElimina"
                    onClick={() => eliminaOrdine(o.ordineID)}
                  >
                    Elimina
                  </button>
                </div>
              )
            })}
            <div className="ordineTotale">
              Totale: €{totale.toFixed(2)}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default OrdiniOggi;